<template>
  <div>
    <h1>This is a Dashboard Page</h1>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "login",
  components: {
    HelloWorld
  }
};
</script>
